/**
 * Non-modal analytics notice under the wordmark and before the location row.
 * It is never autofocused. It lives inside `#root` so the event-detail focus
 * trap's `inert` covers these buttons too.
 */
export function ConsentBanner({
  onAccept,
  onDecline,
}: {
  onAccept: () => void;
  onDecline: () => void;
}): JSX.Element {
  return (
    <section className="consent-banner" aria-labelledby="ga-consent-title">
      <p id="ga-consent-title" className="consent-banner__text">
        We use Google Analytics to understand which events are popular.
      </p>
      <div className="consent-banner__actions">
        <button type="button" className="btn" onClick={onAccept}>
          Accept
        </button>
        <button type="button" className="btn btn-ghost" onClick={onDecline}>
          Decline
        </button>
      </div>
    </section>
  );
}
